import React, { useEffect, useRef, useState } from "react";
import axios from "../../API/axios";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { Dropdown } from "bootstrap";
import { Link } from "react-router-dom";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import PersonAddAlt1SharpIcon from "@mui/icons-material/PersonAddAlt1Sharp";
import PersonRemoveAlt1SharpIcon from "@mui/icons-material/PersonRemoveAlt1Sharp";
import PersonAddAltSharpIcon from "@mui/icons-material/PersonAddAltSharp";
import CheckSharpIcon from "@mui/icons-material/CheckSharp";
import LinkOffSharpIcon from "@mui/icons-material/LinkOffSharp";
import { set } from "lodash";
import { useTranslation } from "react-i18next";
import { Portal } from "../../components/Portal";

const ConnectionRecommendationAction = ({
    showDropdown,
    setShowDropdown,
    item,
    setPR,
    GetRecommendation,
    setRecommendationList,
    index,
}) => {
    const { t } = useTranslation();
    const sessionId = localStorage.getItem("sessionId");
    const [toastMessage, setToastMessage] = useState("");
    const [showToast, setShowToast] = useState(false);
    // console.log("GetRecommendation", GetRecommendation);
    const language = localStorage.getItem("Lang");


    const [warningToastMessage, setWarningToastMessage] = useState("");
    const [showWarningToast, setShowWarningToast] = useState(false);

    const [ErrorToastMessage, setErrorToastMessage] = useState("");
    const [showErrorToast, setShowErrorToast] = useState(false);
    const handleToggleDropdown = (index) => {
        setShowDropdown((prev) => (prev === index ? null : index));
    };
    const dropdownRef = useRef(null);

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setShowDropdown(null);
        }
    };
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const [followedId, setFollowedId] = useState("");
    const [isFollowed, setIsFollowed] = useState(false);
    const [showfollowModal, setShowFollowModal] = useState(false);

    const handleUnfollowCloseModal = () => {
        setShowFollowModal(false);
        // setSelectedItem(null);
    };

    const handleConfirmAction = (id) => {
        unFollowUser(id);
        handleUnfollowCloseModal();
    };

    const FollowedUser = async (id) => {
        console.log("userUid", id, item.userUid);
        setIsFollowed(true);
        setFollowedId(id);
        const data = {
            deviceType: "Web",
            sessionId: sessionId,
            userUID: id,
            langKey: language === "en" ? "" : language,
        };
        try {
            await axios.post("UserFollow/FollowUser", data).then((resData) => {
                setToastMessage(resData.data.message);
                setShowToast(true);
                setIsFollowed(true);
                // setRecommendationList((prev) =>
                //   prev.filter((item) => item.userUid !== id)
                // );
                setRecommendationList((prevList) =>
                    prevList.map((item) =>
                        item.userUid === id ? { ...item, isFollowedByYou: true } : item
                    )
                );
                // GetRecommendation();
                setFollowedId(item?.userUid);
            });
        } catch (error) {

            if (error.response && error.response.status === 404) {
                setWarningToastMessage(error.response.data.message);
                setShowWarningToast(true);
            } else {
                setErrorToastMessage(error.response.data.message);
                setShowErrorToast(true);
            }
        }
    };

    const unFollowUser = async (id) => {
        setIsFollowed(false);
        const responseData = {
            deviceType: "Web",
            sessionId: sessionId,
            userUID: id,
            langKey: language === "en" ? "" : language,
        };
        console.log("unfllow new res", responseData);
        try {
            await axios.post(`UserFollow/UnfollowUser`, responseData).then((res) => {
                console.log("res", res);
                setToastMessage(res.data.message);
                setShowToast(true);
                setIsFollowed(true);
                // setRecommendationList((prev) =>
                //   prev.filter((item) => item.userUid !== id)
                // );
                setRecommendationList((prevList) =>
                    prevList.map((item) =>
                        item.userUid === id ? { ...item, isFollowedByYou: false } : item
                    )
                );
                // GetRecommendation();
                setFollowedId(item?.userUid);
            });
        } catch (e) {
            console.log('cxc', e);
            setIsFollowed(false);
            setFollowedId(null);
            if (e.response && e.response.status === 404) {
                setWarningToastMessage(e.response.data.message);
                setShowWarningToast(true);
            } else {
                setErrorToastMessage(e.response.data.message);
                setShowErrorToast(true);
            }
        }
    };


    //************************ Connect User Start  ************************//
    const [connectId, setConnectId] = useState("");
    const [userUID, setuserUID] = useState("");

    const ConnectUser = async (id) => {
        const data = {
            deviceType: "Web",
            sessionId: sessionId,
            userUID: id,
            langKey: language === "en" ? "" : language,
        };

        try {
            const resData = await axios.post("Connection/SendConnectionRequest", data);
            console.log("isConnect===>", resData);
            setToastMessage(resData.data.message);
            setShowToast(true);

            // setRecommendationList((prev) => prev.filter((item) => item.userUid !== id));
            setRecommendationList((prevList) =>
                prevList.map((item) =>
                    item.userUid === id ? { ...item, isConnectedByYou: true } : item
                )
            );
            
            // setCheckConnect(true)
            setConnectionCheck("Sent");
            //  GetRecommendation();

        } catch (error) {
            if (error.response && error.response.status === 404) {
                setWarningToastMessage(error.response.data.message || "Something went wrong");
                setShowWarningToast(true);
            } else if (error.response) {
                setErrorToastMessage(error.response.data?.message || "Something went wrong");
                setShowErrorToast(true);
            } else {
                setErrorToastMessage(error.response.data.message || "Network error, please try again");
                setShowErrorToast(true);
            }
        }
    };

    //=================Cancel Request API Call===============//

    const CancelRequest = async () => {
        const data = {
            deviceType: "Web",
            sessionId: sessionId,
            userUID: userUID,
            langKey: language === "en" ? "" : language,
        };

        try {
            const resData = await axios.post("Connection/CancelConnectionRequest", data);
            // console.log("Cancel Connect===>", resData);
            setShow(false);
            setToastMessage(resData?.data?.message);
            setShowToast(true);
            setConnectionCheck(null);

            setRecommendationList((prevList) =>
                prevList.map((item) =>
                    item.userUid === userUID
                        ? { ...item, isConnectedByYou: false }
                        : item
                )
            );
            // GetRecommendation();
            setShow(false);

        } catch (e) {
            if (e?.response && e?.response?.status === 404) {
                setWarningToastMessage(e?.response?.data?.message || "Something went wrong");
                setShowWarningToast(true);
            } else if (e?.response) {
                setErrorToastMessage(e?.response?.data?.message || "Something went wrong");
                setShowErrorToast(true);
            }
            else {
                setErrorToastMessage(e?.response?.data?.message || "Network Error");
                setShowErrorToast(true);
            }
        }
    };

    //************************ Connect User  End  ************************//
    //************************Cancel Request   ************************//
    const [showModal, setShowModal] = useState(false);
    const handleShowModal = (item) => {
        // setSelectedItem(item);
        // setSelectedUserId(item.userUid);
        setShowModal(true);
    };
    const handleCloseModal = () => {
        setShowModal(false);
        // setSelectedItem(null);
    };
    const [show, setShow] = useState(false);
    const cancelRequestOpen = () => {
        setShow(true);
    };
    const cancelRequestClose = () => {
        setShow(false);
    };
    // const [skillId, setSkillId] = useState("");
   //************************Disconnect Request   ************************//
   
 const [showModalDisC, setShowModalDisC] = useState(false);
  const handleShowModalc = ( ) => {  
    setShowModalDisC(true);
  };

  const handleClose = () => {
    setShowModalDisC(false); 
  };
  const DisconnectUser = async () => { 
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: connectId,
      langKey: language === "en" ? "" : language,
    };
    console.log(data);
    try {
      await axios.post("Connection/DisconnectUser", data).then((resData) => {
        console.log(resData);
        // setShowModalDisC(!showModalDisC);
        //   toast.success(resData.data.message);
        setConnectionId(null);
        setToastMessage(resData.data.message);
        setShowToast(true);
        setConnectionCheck(null);  
        CheckConnectUser(item?.userUid);
        handleClose()
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Disconnect Request ************************//
  //************************Accept Request   ************************//
  const AcceptRequest = async ( ) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID:  item?.userUid,
      // connectID: cnctnId,
      actionType: "Accept",
      langKey: language === "en" ? "" : language,
    };
    console.log('cnctnId', data);

    try {
      await axios
        .post("Connection/ConnectionRequestAction", data)
        .then((resData) => {
          setToastMessage(resData.data.message);
          setShowToast(true);
          
        setConnectionCheck("Connected");  
        CheckConnectUser(item?.userUid);
        //   setRecievedRequest( );
         });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Accept Request ************************//

  //************************Reject Request   ************************//
  const RejectRequest = async (userId, cnctnId) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: userId,
      // connectID: cnctnId,
      actionType: "Reject",
      langKey: language === "en" ? "" : language,
    };
    // console.log(data);
    try {
      await axios
        .post("Connection/ConnectionRequestAction", data)
        .then((resData) => {
          setToastMessage(resData.data.message);
          setShowToast(true);
        //   setRecievedRequest((prev) => prev.filter((item) => item.userUid !== userId));
        //   ReceivedRequestList();
        });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Reject Request ************************//

    const [connectionCheck, setConnectionCheck] = useState("");
    console.log("connectionCheck", connectionCheck);
  
    const [connectionId, setConnectionId] = useState("");
    // api removed from backend
    const CheckConnectUser = async (id) => {
      const data = {
        deviceType: "Web",
        sessionId: sessionId,
        userUID: id,
        langKey: language === "en" ? "" : language,
      };
      try {
        await axios.post("Connection/CheckConnection", data).then((resData) => {
          console.log("checkFollowedUser", resData.data);
          if (resData.data.status === "Warning") {
            // setConnectionCheck("Connect");
            // } else {
            setConnectionCheck(resData.data.responseData.value);
            setConnectionId(resData.data.responseData.id);
          }
        });
      } catch (error) {
        console.log(error);
      }
    };

    useEffect(() => {
    if (item?.postOriginType !== "Company" && 
      item?.isConnectedByYou  === null) {
      CheckConnectUser(item.userUid);
    }
}, [item?.isConnectedByYou]);
console.log("checkingggg", item.isConnectedByYou);


//   const isConnectedCheck = connectionCheck === "Connected";
//   const isRequestSent = connectionCheck === "Sent";
//   const isRequestReceived = connectionCheck === "Received"; 
//   const isNoConnection =
//   !connectionCheck || connectionCheck === null;
// const isConnected =
//   connectionCheck === "Connected" || item?.isConnectedByYou === true;

const status =
  connectionCheck ||
  (item?.isConnectedByYou === true ? "Connected" : "None");

const isConnected = status === "Connected";
const isRequestSent = status === "Sent";
const isRequestReceived = status === "Received";
const isNoConnection = status === "None";

    return (
        <>
            <div className="wlj-card-actions">
            {item?.isFollowedByYou ? (
                <button
                    type="submit"
                    className="wljDangerBtn wlj-chip-btn"
                    onClick={() => {
                        setShowFollowModal(true);
                        setFollowedId(item.userUid);
                    }}
                >
                    <PersonRemoveAlt1SharpIcon />
                    {t("Connections.Unfollow")}
                </button>
            ) : (
                <button
                    type="submit"
                    className="wljPrimaryBtn wlj-chip-btn"
                    onClick={() => FollowedUser(item.userUid)}
                >
                    <PersonAddAlt1SharpIcon />
                    {t("Connections.Follow")}
                </button>
            )}
              {isNoConnection && (
  <button
    className="wljPrimaryBtn wlj-chip-btn"
    onClick={() => ConnectUser(item.userUid)}
  >
    <PersonAddAltSharpIcon />
    {t("Connections.Connect")}
  </button>
)}
{isRequestSent && (
  <button
    className="wljDangerBtn wlj-chip-btn"
    onClick={() => {
      cancelRequestOpen();
      setuserUID(item.userUid);
    }}
  >
    <CloseSharpIcon />
    {t("Connections.Cancel")}
  </button>
)}
{isRequestReceived && (
  <button
    className="wljPrimaryBtn wlj-chip-btn"
    onClick={() => {
      AcceptRequest();
      setConnectId(item.userUid);
    }}
  >
    <CheckSharpIcon />
    {t("Connections.Accept")}
  </button>
)}
{isConnected && (
  <button
    className="wljDangerBtn wlj-chip-btn"
    onClick={() => {
      DisconnectUser();
      setConnectId(item.userUid);
      setConnectionCheck("None");
    }}
  >
    <LinkOffSharpIcon />
    {t("Connections.Disconnect")}
  </button>
)}
            </div>

     {/* {isRequestSent &&  (
                     <button
                                        type="submit"
                                        style={{ width: '100px', marginRight: "5px" }}
                                        className="wljSecondaryBtn"
                                        onClick={() => {
                                            cancelRequestOpen();
                                            setuserUID(item.userUid);
                                        }}
                                        >
                                        {t("Connections.Cancel")}
                                            
                                        </button>
                    )}
                    { isConnected && isRequestReceived && isRequestSent &&  (
                       <button
                                        type="submit"
                                        className="wljPrimaryBtn"
                                        style={{ width: "100px" ,  marginRight: "5px"}}
                                        onClick={() => {
                                            ConnectUser(item.userUid);
                                            // setConnectId(item.userUid);
                                        }}
                                        >
                                        
                                        {t("Connections.Connect")}
                                        </button>
                    )}
                    {isRequestReceived &&  (
                       <button
                                        type="submit"
                                        className="wljPrimaryBtn"
                                        style={{ width: "100px" ,  marginRight: "5px"}}
                                        onClick={() => {
                                            AcceptRequest();
                                            setConnectId(item.userUid);
                                        }}
                                        >
                                        
                                        {t("Connections.Accept")}
                                        </button>
                                )}
                                {isConnectedCheck || item?.isConnectedByYou === true &&  (
                                <button
                                        type="submit"
                                        className="wljPrimaryBtn"
                                        style={{ width: "100px" ,  marginRight: "5px"}}
                                        onClick={() => {
                                            DisconnectUser();
                                            setConnectId(item.userUid);
                                        }}
                                        >
                                        
                                        {t("Connections.Disconnect")}
                                        </button>
                    )} */}

            <SuccessToast
                show={showToast}
                message={toastMessage}
                onClose={() => setShowToast(false)}
            />

            <WarningToast
                show={showWarningToast}
                message={warningToastMessage}
                onClose={() => setShowWarningToast(false)}
            />

            <ErrorToast
                show={showErrorToast}
                message={ErrorToastMessage}
                onClose={() => setShowErrorToast(false)}
            />
            {show && (
                <div
                    className="modal fade show postAdd"
                    tabIndex="-1"
                    role="dialog"
                    style={{ display: "block" }}
                >
                    <div className="modal-dialog  modal-dialog-centered " role="document">
                        <div className="modal-content d-flex justify-content-around p-2">
                            <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                                <h6>{t("modals.Are You Sure You want to Cancel Request?")}</h6>

                                <CloseSharpIcon
                                    className="material-symbols-sharp me-2 pointer"
                                    onClick={() => {
                                        cancelRequestClose();
                                    }}
                                />
                            </div>

                            <div className="text-center mt-2">
                                <button
                                    color=""
                                    className="wljDangerBtn"
                                    onClick={() => CancelRequest()}
                                >
                                    {t("modals.Yes")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showModalDisC && (
                <Portal layer="modal">
                <div
                    className="modal fade show postAdd"
                    tabIndex="-1"
                    role="dialog"
                    style={{ display: "block" }}
                >
                    <div className="modal-dialog  modal-dialog-centered " role="document">
                        <div className="modal-content d-flex justify-content-around p-2">
                            <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                                <h6>
                                   {t("modals.Are you sure you want to Disconnect")}
                                    {/* <b>{selectedItem?.fullName}</b> ? */}
                                </h6> 
                                <CloseSharpIcon
                                    className="material-symbols-sharp me-2 pointer"
                                    onClick={() => {
                                        handleClose();
                                    }}
                                />
                            </div>

                            <div className="text-end mt-2">
                                <button
                                    color=""
                                    className="wljDangerBtn"
                                    onClick={() => DisconnectUser()}
                                >
                                    {t("modals.Yes")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                </Portal>
            )}

            {showfollowModal && (
                <Portal layer="modal">
                <div
                    className="modal fade show postAdd"
                    tabIndex="-1"
                    role="dialog"
                    style={{ display: "block" }}
                >
                    <div className="modal-dialog  modal-dialog-centered " role="document">
                        <div className="modal-content d-flex justify-content-around p-2">
                            <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                                <h6>
                                    {/* Are you sure you want to unfollow{" "} */}
                                    {t("modals.Are you sure you want to unfollow")}                                </h6>

                                {/* <span
                       
                      >
                        close
                      </span> */}
                                <CloseSharpIcon
                                    className="material-symbols-sharp me-2 pointer"
                                    onClick={() => {
                                        handleUnfollowCloseModal();
                                    }} />
                            </div>

                            <div className="text-center mt-2">
                                <button
                                    color=""
                                    className="wljDangerBtn"
                                    onClick={() => handleConfirmAction(item.userUid)}
                                >
                                    {t("Recommendations.Unfollow")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                </Portal>
            )}

        </>
    );
};

export default ConnectionRecommendationAction;
